import { formatDate } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import moment from 'moment';
import { BcbService } from 'src/app/services/bcb/bcb.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { OrdonnanceNumeriqueService } from 'src/app/services/ordonnance-numerique/ordonnance-numerique.service';
import { RessourceService, scannerIsCom, scannerIsUsb } from 'src/app/services/ressource/ressource.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { RechercheBcbProduit } from 'src/app/utils/interfaces/new/recherche-bcb-produit.interface';
import { environment } from 'src/environments/environment';

const gs: string = String.fromCharCode(29);

export class VaccineDetails {
  cip13?: string;
  expirationDate?: Date;
  bacthNumber?: string;
  serialNumber?: string;
  nom?: string;
}

export enum TypeScan {
  VACCIN,
  EPRESCRIPTION,
}


const runTests = false;
const realStringCode = "01012345678901281722033110A12W12321X12345678";
const goodStringCode = "10A12W12321X12345678172203310101234567890128";
const anotherGoodStringCodeWith00Day = "01012345678901281722030010A12W12321X12345678";
const wrongStringCodeButNear = "(01)01234567890128(17)220331(10)A12W123(21)X12345678";
const totallyWrongStringCode = "FRH645GGR428293G3HD8757773GG377TF87TBC8T836TD";

@Component({
  selector: 'app-datamatrix-reader',
  templateUrl: './datamatrix-reader.component.html',
  styleUrls: [
    './datamatrix-reader.component.scss',
    '../../fragments/modal/modal.fragment.scss'
  ]
})
export class DatamatrixReaderComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter();
  private currentProfil: Profil;
  private onConfirmation: boolean = false;

  public availableDevices: MediaDeviceInfo[] = [];
  public deviceCurrent: MediaDeviceInfo = null;
  public deviceSelected: string;

  public hasDevices: boolean;
  public hasPermission: boolean;

  public loading: boolean = false;
  public videoLoading = false;

  public readMode: TypeScan = TypeScan.VACCIN;

  public scannedCode: string = ''; 
  private scanTimeout: any; 
  scanActive = false;
  buffer = '';
  lastKeyTime = 0;
  lastScan: string | null = null;
  scanTimeoutId: any; 
  SCAN_TIMEOUT_MS = 30000; 

  public isBCBLicence : boolean;
  public isPortCom: boolean;
  public isPortUsb: boolean;

private currentPort: SerialPort | null = null;


  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModalVaccin();
    }
  }

  constructor(
    private _view: ViewContainerRef,
    private _modal: ModalService,
    private _snack: SnackbarService,
    private _bcbSrv: BcbService,
    private _eprescription: OrdonnanceNumeriqueService,
    private _resourceSrv: RessourceService,
  ) { }

   async ngOnInit(): Promise<void> {
    if (runTests) {
      console.log("REAL STRING CODE : " + realStringCode + " => ", this.extractVaccinInfoFromCode(realStringCode));
      console.log("GOOD STRING CODE : " + goodStringCode + " => ", this.extractVaccinInfoFromCode(goodStringCode));
      console.log("ANOTHER GOOD STRING CODE WITH 00 DAY : " + anotherGoodStringCodeWith00Day + " => ", this.extractVaccinInfoFromCode(anotherGoodStringCodeWith00Day));
      console.log("WRONG STRING CODE BUT NEAR : " + wrongStringCodeButNear + " => ", this.extractVaccinInfoFromCode(wrongStringCodeButNear));
      console.log("TOTALLY WRONG STRING CODE : " + totallyWrongStringCode + " => ", this.extractVaccinInfoFromCode(totallyWrongStringCode));
    }
  await this.getUserPreferences()
}

/**
 * Récupère les préférences de l'utilisateur pour la configuration de son lecteur (usb ou com)
 * Si pas de préférence, par défaut usb est sélectionné.
 */
async getUserPreferences(): Promise<void> {
  const currentProfilStr = localStorage.getItem('currentProfil');
      if (!currentProfilStr) return;
  
      this.currentProfil = JSON.parse(currentProfilStr);
      if (!this.currentProfil?.id) return;
  
      const params = await this._resourceSrv.getResourceSettings(
        this.currentProfil.id,
        'profil'
      );
      if (!params) return;
  
      const usbSetting = params.find((p) => p.settingKey === scannerIsUsb);
      const comSetting = params.find((p) => p.settingKey === scannerIsCom);

      if (usbSetting?.settingValue === 'true') {
        this.isPortUsb = true;
        this.isPortCom = false;
       
      } else if (comSetting?.settingValue === 'true') {
        this.isPortCom = true;
        this.isPortUsb = false;

      } else {
        this.isPortUsb = true;
        this.isPortCom = false;

      }
  }
  /**
   * Permet de choisir la caméra ou le lecteur depuis l'interface
   */
  onInputTypeChange(inputType: string): void {
  this.deviceSelected = inputType;
  this.scannedCode = '';

  if (inputType === 'scanner') {
    this.videoLoading = false;
    this.hasPermission = false;
    this.availableDevices = [];
    this.loading = false;
  } else if (inputType === 'camera') {
    this.videoLoading = true;
    this.loading = false;
  }
  }
/**
 * Active le mode scan (pendant 30 secondes si on est en usb) et initialise le buffer.
 */
  enableScan() {
  this.scanActive = true;
  this.buffer = '';
  this.lastScan = null;

  if (this.isPortUsb){
    clearTimeout(this.scanTimeoutId);
    this.scanTimeoutId = setTimeout(() => {
      this.disableScan();
      this._snack.openSnackBar('Le scan a été désactivé après 30 secondes d’inactivité.');
    }, this.SCAN_TIMEOUT_MS);
  }
  
}

/**
 * Désactive le mode scan, réinitialise le buffer et le timeout.
 */
  disableScan() {
    this.scanActive = false;
    this.buffer = '';
    if (this.isPortUsb){
      this.lastKeyTime = 0;
      clearTimeout(this.scanTimeoutId);
    }
  }
 /**
  * Ecoute les frappes clavier pour détecter les scans.
  */
  @HostListener('document:keydown', ['$event'])
  onKeydown(e:KeyboardEvent){
    if (!this.scanActive) return;
    const now = Date.now();
    let delta = 0;

    if (this.lastKeyTime) {
      delta = now - this.lastKeyTime;
    }
    this.lastKeyTime = now;

    if (delta > 150 && delta !== 0) {
      console.error(`Reset buffer, delta trop long: ${delta}`);
      this.buffer = '';
    }
    if (e.key === 'Enter') {
      this.lastScan = this.buffer;
      this.handleScannerEvent(this.buffer);
      this.buffer = '';
    } else if (e.key.length === 1) {
      this.buffer += e.key;
    }
  }

/**
 * Le scan n'est détecté que si l'utilisateur clique sur le bouton, 
 * cela est une mesure de sécurité.
 */
  startScannerInput(): void {
    if (this.deviceSelected === 'scanner') {
      this.scannedCode = '';
      this.enableScan()
    }
  }
/**
 * Vide le buffer interne du scanner COM avant de commencer un nouveau scan.
 */
async emptyScannerInnerBuffer(): Promise<void> {
  if (!this.currentPort) return;

  const reader = this.currentPort.readable.getReader();
  try {
    while (true) {
      const readPromise = reader.read();
      const timeoutPromise = new Promise<{ done: boolean; value: undefined }>(
        (resolve) =>
          setTimeout(() => resolve({ done: true, value: undefined }), 100)
      );

      const { done, value } = await Promise.race([readPromise, timeoutPromise]);

      if (done) {
        break;
      }
    }
  } catch (err) {
    console.error('Error draining buffer:', err);
  } finally {
    reader.releaseLock();
  }
}


/**
 * Gère le scan par port COM via l'API Web Serial.
 * Nécessite que l'utilisateur ait cliqué sur le bouton pour des raisons de sécurité.
 * Lit un seul scan puis ferme le port.
 * Affiche une erreur si l'API n'est pas supportée ou si une erreur survient.
 */
async handlePortComEvent(): Promise<void> {
  if (this.deviceSelected !== 'scanner' || !this.isPortCom) return;

  if (!('serial' in navigator)) {
    this._snack.openSnackBarError("Web Serial API non supportée par ce navigateur.");
    return;
  }

  try {
    if (!this.currentPort) {
      this.currentPort = await navigator.serial.requestPort();
      await this.currentPort.open({ baudRate: 9600, flowControl: 'none' });
    }
    await this.emptyScannerInnerBuffer();
    this.enableScan();

    const textDecoder = new TextDecoderStream();
    const readableStreamClosed = this.currentPort.readable.pipeTo(
      textDecoder.writable as WritableStream<Uint8Array>
    );

    const reader = textDecoder.readable.getReader();
    let fullValue = '';
     let inactivityTimer: any;

    
    const startInactivityTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(async () => {
        try {
          await reader.cancel();
        } catch {}
        try {
          if (this.currentPort) {
            await this.currentPort.close();
            this.currentPort = null;
          }
        } catch {}
        this.disableScan();
        this._snack.openSnackBar("Le scan a expiré après 30 secondes d'inactivité.");
      }, 30000);
    };

    startInactivityTimer(); 

    try {
      while (true) {
        const { value, done } = await reader.read();
        if (done) {
          break;
        }

        if (value) {
          fullValue += value; // concatène les morceaux

          // Si la lecture semble complète (longueur suffisante et termine par un séparateur ou un GS)
          if (fullValue.length > 20 && /[\x1D\n\r]$/.test(fullValue)) {
            this.handleScannerEvent(fullValue);
            break;
          }
        }
      }

      await reader.cancel();
      await readableStreamClosed.catch(() => {});

    } finally {
      reader.releaseLock();
      if (this.currentPort) {
        await this.currentPort.close();
        this.currentPort = null;
      }
      this.disableScan();
    }

  } catch (err) {
    console.error("Erreur Web Serial API", err);
    if (this.currentPort) {
      try { await this.currentPort.close(); } catch {}
      this.currentPort = null;
    }
  }
}


/**
 * Vérifie le pattern de la chaine reçue avant de la traiter, mesure de sécurité.
 */
handleScannerEvent(buffer: string): void {
  if (this.deviceSelected !== 'scanner') return;
  if (!this.scanActive) return;
  this.loading = true;

  if (!this.isValidVaccineCode(buffer) && this.readMode === TypeScan.VACCIN) {
    this._snack.openSnackBarError('Le code scanné ne correspond pas au format attendu pour un vaccin.');
    this.buffer = '';
    return;
  }

 if (this.isPortUsb) {
    clearTimeout(this.scanTimeout);
    this.scanTimeout = setTimeout(() => {
      this.scanSuccessHandler(buffer);
      this.disableScan();
    }, 200);
  } else if (this.isPortCom) {
    this.scanSuccessHandler(buffer);
  }
}


  public onDeviceChange(device: MediaDeviceInfo | null): void {
  if (!device) {
    this.deviceCurrent = null; 
    return;
  }

  this.deviceCurrent = device;
}

  public onHasPermission(has: boolean) {
    this.hasPermission = has;
    if (!has) {
      this.videoLoading = false;
      this.loading = false;
    }
  }

  public camerasFoundHandler(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    this.hasDevices = devices && devices.length > 0;
    this.videoLoading = false;
    this.loading = false;
  }

  public camerasNotFoundHandler(event: any): void {
    this.availableDevices = [];
    this.hasDevices = false;
    this.videoLoading = false;
    this.loading = false;
  }

/**
 * Vérifie si le code scanné suit le pattern attendu d'un DataMatrix vaccin.
 * Evite les injections de codes qui ne correspondent pas au format attendu.
 */
private isValidVaccineCode(buffer: string): boolean {
  if (!buffer) {
    console.warn("Le buffer est vide.")
    return false;
  }

  if (!buffer.startsWith('01')) {
    console.warn("Le buffer ne commence pas par '01'.");
    return false;
  }

  const hasBatchOrDate = buffer.includes('10') || buffer.includes('17');
  if (!hasBatchOrDate) {
    console.warn("Le buffer ne contient pas de numéro de lot ou de date.");
    return false;
  }

  if (buffer.length < 20 || buffer.length > 80) {
    console.warn("Le buffer a une longueur invalide.");
    return false;
  }

   // Caractères autorisés : 0-9, A-Z, / \ - . et les caractères de contrôle \r, \n, et le GS (ASCII 29)
  const validCharsRegex = /^[0-9A-Z\/\\\-.\r\n\x1D]+$/;

  if (!validCharsRegex.test(buffer)){
    console.warn("Invalid chars in code:", buffer);
    return false;
  } 

  return true;
}

/**
 * Gère le succès du scan en fonction du mode de lecture (vaccin ou ePrescription).
 */
  public async scanSuccessHandler(event: any): Promise<void> {
    if (event && !this.onConfirmation) {
      this.scannedCode = event; 
        switch (this.readMode) {
          case TypeScan.VACCIN:
            await this.scanSuccessHandlerVaccin(event);
            break;
          case TypeScan.EPRESCRIPTION:
            await this.scanSuccessHandlerEPrescription(event);
            break;
          default:
            break;
        }
    this.scannedCode = '';
    }
  }
  
  public async scanSuccessHandlerEPrescription(event: any): Promise<void> {
    try {
      const qrcodeInfo = this._eprescription.validateQRCode(event);
      if (qrcodeInfo) {
        this.onConfirmation = true;
        const confirmMessageArr = [];
        confirmMessageArr.push(`Version : ${qrcodeInfo.S.V}`);
        confirmMessageArr.push(`Numéro : ${qrcodeInfo.D.ID}`);
        confirmMessageArr.push(`RPPS Prescripteur : ${qrcodeInfo.D.M.RPPS}`);
        confirmMessageArr.push( `Patient : ${qrcodeInfo.D.P.P.trim()} ${qrcodeInfo.D.P.N.trim()} (${qrcodeInfo.D.P.D.replace(/=/g, '-')})`);
        confirmMessageArr.push(``);
        confirmMessageArr.push(`Voulez-vous importer ce numéro ePrescription pour recherche ?`);
        const confirmMessage = confirmMessageArr.join('\n\r');

        const modal = this._modal.openModalConfirmation(this._view, "Information ordonnance numérique", confirmMessage, undefined, true);
        const sub = modal.instance.closeEmitter.subscribe((resp) => {
          this._modal.close(modal);
          this.onConfirmation = false;
          if (resp) {
            this.closeModalEprescription(qrcodeInfo.D.ID);
          }
          sub.unsubscribe();
        });
      }
    } catch (error) {
      this.onConfirmation = true;
      const modal = this._modal.openAlert(this._view, "Erreur", "Le QRCode de cette ordonnance numérique n\'est pas valide.\n\r", undefined, error.message);
      const sub = modal.instance.closeEmitter.subscribe((resp) => {
        this._modal.close(modal);
        this.onConfirmation = false;
        sub.unsubscribe();
      });
    } finally {
          this.loading = false;
    }
    }
/**
 * On recherche le nom du vaccin via le CIP13 si la licence BCB est valide.
 * Si pas de licence le nom est à inscrire manuellement.
 */
 public async scanSuccessHandlerVaccin(event: any): Promise<void> {
  this.isBCBLicence = await this._bcbSrv.isLicenceOk();
  this.loading = true; 
  let details: VaccineDetails = {
    cip13: undefined,
    expirationDate: undefined,
    bacthNumber: undefined,
    serialNumber: undefined,
    nom: undefined,
  };
  try {
    details = this.extractVaccinInfoFromCode(event);

    if (details.cip13 && details.expirationDate && details.bacthNumber) {
      this.onConfirmation = true;

      let vaccFromCip: RechercheBcbProduit[] = [];
      if (this.isBCBLicence) {
        try {
          vaccFromCip =
            (await this._bcbSrv.rechercheProduitByCodeCip(details.cip13)) || [];
        } catch (error) {
          console.error(
            'Erreur lors de la récupération de la terminologie:',
            error
          );
        }
      } else {
        this._snack.openSnackBarError(
          "La licence BCB n'est pas valide. Impossible de récupérer le nom du vaccin."
        );
        vaccFromCip = [];
      }
     
      const confirmMessageArr = [];
      if (vaccFromCip.length > 0 && vaccFromCip[0].libelle) {
        details.nom = vaccFromCip[0].libelleCourt;
        confirmMessageArr.push(`Nom : ${details.nom}`);
      }
      confirmMessageArr.push(`CIP : ${details.cip13}`);
      confirmMessageArr.push(`Date d'expiration : ${formatDate(details.expirationDate, "dd/MM/yyyy", "fr")}`);
      confirmMessageArr.push(`Numéro de lot : ${details.bacthNumber}`);
      confirmMessageArr.push(`Voulez-vous ajouter un vaccin avec ces informations ?`);
      const confirmMessage = confirmMessageArr.join('\n\r');

      const confirmModal = this._modal.openModalConfirmation(this._view, "Information vaccin", confirmMessage, undefined, true);
      const confirmSub = confirmModal.instance.closeEmitter.subscribe((resp) => {
        this._modal.close(confirmModal);
        this.onConfirmation = false;
        if (resp) {
          this.closeModalVaccin(details);
        }
        confirmSub.unsubscribe();
      });
    } else {
      this._snack.openSnackBarError('Le code n\'a pas pu être lu correctement. Veuillez réessayer ou vous assurer qu\'il s\'agit bien d\'un code issu d\'une boite de vaccin.');
    }
  } catch (error) {
    console.error("Erreur lors du traitement du vaccin :", error);
    this._snack.openSnackBarError('Une erreur est survenue lors de la lecture du vaccin. Veuillez réessayer.');
  } finally {
    this.loading = false; 
  }
}
  // https://www.france-mvo.fr/wp-content/uploads/2021/11/Fiche-Technique-Jeu-de-test-DM-n5_V07.pdf
  // Fiche technique pour encoder/decoder des Datamatrix de produits médicamenteux
  public extractVaccinInfoFromCode(code: string): VaccineDetails {
    const cleanedCode = code.replace(/Shift(\w)/g, '$1').replace(/Enter/g, '').trim();// clean le code lu par le lecteur qui apparait sous forme d'un string avec des "shift0shift2...."
    // Instanciation du résultat
    let result: VaccineDetails = {
      cip13: null,
      expirationDate: null,
      bacthNumber: null,
      serialNumber: null,
    };
    if (this.deviceSelected === 'camera') {
      const codeWithoutFirstChar = cleanedCode.substring(1);
      let stayInLoop = true;
      let state = { result: result, rest: codeWithoutFirstChar };
      while (stayInLoop) {
        const firstTwoChars = state.rest.substring(0, 2);
        const restOfCode = state.rest.substring(2);
        state = this._extractSubCode(firstTwoChars, restOfCode, state.result);
        if (state.rest === '') {
          stayInLoop = false;
        }
      }
      result = state.result;
      return result;

    } else if (this.deviceSelected === "scanner") {

      let stayInLoop = true;
      let state = { result: result, rest: cleanedCode };
      while (stayInLoop) {
        const firstTwoChars = state.rest.substring(0, 2);
        const restOfCode = state.rest.substring(2);
        state = this._extractSubCode(firstTwoChars, restOfCode, state.result);
        if (state.rest === '') {
          stayInLoop = false;
        }
      }
      result = state.result;
      return result;
    }
  }

  private _extractSubCode(indicator: string, stringCode: string, details: VaccineDetails): { result: VaccineDetails, rest: string } {
      if (this.isPortCom){
            stringCode = stringCode.replace(/\x1D/g, ''); 
      }
    switch (indicator) {
      case '01':
        const cip13 = this._extractCip13(stringCode);
        let restCip = '';
        if (cip13 && cip13.length == 13) {
          restCip = stringCode.substring(cip13.length + 1); // +1 pour le 0 de debut
        }
        details.cip13 = cip13;
        return { result: details, rest: restCip };
      case '10':
        const batch = this._extractBatchNumber(stringCode);
        let restBatch = stringCode.substring(batch.length);
        if (batch.length < 20) {
          restBatch = restBatch.substring(1);
        }

        details.bacthNumber = batch;
        return { result: details, rest: restBatch };
      case '17':
        const expDate = this._extractExpirationDate(stringCode);
        const restDate = stringCode.substring(expDate.length);
        details.expirationDate = this._extractDateFromExpDateCode(expDate);
        return { result: details, rest: restDate };
      case '21': // Souvent le '17' n'a pas de séparateur et se retrouve contenu dans le '21'
        const serNum = this._extractSerialNumber(stringCode);
        let restSerial = stringCode.substring(serNum.length);

        if (!details.expirationDate) {//Si pas de '17' on cherche s'il est présent dans la chaine
          const regex = /17\d{6}/g;//S'il y a plusieurs '17' on recherche celui qui est suivi de 6 chiffres (date)
          let match;
          let lastMatchIndex = -1;

          while ((match = regex.exec(serNum)) !== null) {
            lastMatchIndex = match.index!;
          }

          if (lastMatchIndex >= 0) {
            details.serialNumber = serNum.substring(0, lastMatchIndex);
            const datePart = serNum.substring(lastMatchIndex); 
            restSerial = datePart + restSerial;
          } else {
            details.serialNumber = serNum;
          }
        } else {
          details.serialNumber = serNum;
        }

        return { result: details, rest: restSerial };

      default:
        return { result: details, rest: '' };
    }
  }

  private _extractDateFromExpDateCode(expDate?: string): Date | null {
    if (!expDate) {
      return null;
    }
    let realDate = "";
    if (expDate.substring(4) === "00") {
      realDate = "20" + expDate.substring(0,2) + "-" + expDate.substring(2,4) + "-01";
      realDate = "20" + expDate.substring(0,2) + "-" + expDate.substring(2,4) + "-" + moment(realDate).endOf('month').format('DD');
    } else {
      realDate = "20" + expDate.substring(0,2) + "-" + expDate.substring(2,4) + "-" + expDate.substring(4);
    }
    return moment(realDate).toDate();
  }

  private _extractCip13(stringCode: string): string | undefined {
    // Un CIP13 est composé de 13 chiffres
    // Si le CIP14 commence par un 0, on l'enlève pour faire un CIP13
    let stringCodeClean = stringCode
    if (stringCodeClean.length > 14) {
      stringCodeClean = stringCode.substring(0, 14);
    }
    if (stringCodeClean.length == 14 && stringCodeClean.substring(0, 1) == "0") {
      return stringCodeClean.substring(1, 14);
    } else if (stringCodeClean.length == 13) {
      return stringCodeClean;
    } else {
      return;
    }
  }

  private _extractExpirationDate(stringCode: string): string | null {
   // Vérification pour s'assurer que la chaîne est de la bonne longueur
    if (stringCode.length > 6) {
        return stringCode.substring(0, 6);
    } else if (stringCode.length < 6) {
        return null;
    } else {
        return stringCode;
    }
}

  private _extractBatchNumber(stringCode: string): string | null {
    const groupSeparatorIndex = stringCode.indexOf(gs);
    if (groupSeparatorIndex === -1) {
      if (stringCode.length > 20) {
        return stringCode.substring(0, 20);
      } else {
        return stringCode.length === 0 ? null : stringCode;
      }
    } else {
      return stringCode.substring(0, groupSeparatorIndex);
    }
  }

  private _extractSerialNumber(stringCode: string): string | null {
    const groupSeparatorIndex = stringCode.indexOf(gs);
    if (groupSeparatorIndex === -1) {
      if (stringCode.length > 20) {
        return stringCode.substring(0, 20);
      } else {
        return stringCode.length === 0 ? null : stringCode;
      }
    } else {
      return stringCode.substring(0, groupSeparatorIndex);
    }
  }

  public scanErrorHandler(event: any): void {
    if (event) {
      console.log('scanErrorHandler - event : ', event);
    }
  }

  public scanFailureHandler(event: any): void {
    // if (event) {
    //   console.log('scanFailureHandler - event : ', event);
    // }
  }

  public scanCompleteHandler(event: any): void {
    if (event) {
      //console.log('scanCompleteHandler - event : ', event);
    }
  }

  public closeModal(): void {
    if(this.deviceSelected === 'scanner'){
      this.disableScan();
    }
    this.closeEmitter.emit();
  }

  public closeModalEprescription(obj?: string) {
    this.closeEmitter.emit(obj);
  }

  public closeModalVaccin(obj?: VaccineDetails): void {
    // if (obj) {
    //   obj.cip13 = '3400935310866';
    // }

    this.closeEmitter.emit(obj);
  }

}
